import React, { useState, useEffect } from "react";
import api from "../api/axios";
import { useHistory,Link } from "react-router-dom";
import { toast } from "react-toastify";

const AddUser = () => {
  const user_detail = JSON.parse(localStorage.getItem("user-list"));
  const storedUserDetail = user_detail;

  const isEditMode = storedUserDetail?.id;

  const history = useHistory();
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    phone: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let response;
      let url;
      let method; 

      if (isEditMode) {
        url = `/user/update/${isEditMode}`;
        method = api.post; 
      } else {
        url = "/user/add"; 
        method = api.post;
      }

      response = await method(url, formData, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.data.success) {
        const successMessage = isEditMode
          ? "User data updated successfully!"
          : "User added successfully!";
       
        toast.success(successMessage);
        history.push("/users");
      } else {
        toast.error(response.data.message);       
      }
    } catch (err) {
      console.error("Submission error:", err);
      const apiErrors = err.response?.data?.errors;
      if (apiErrors) {
          toast.error("Validation failed: " + Object.values(apiErrors).flat().join(" | "));
      } else {
        toast.error("Error submitting user data!");
      }
    }
  };

  return (
    <>
      <div className="main-content-inner">
        {/* <!-- main-content-wrap --> */}
        <div className="main-content-wrap">
          <div className="flex items-center flex-wrap justify-between gap20 mb-27">
            <h3>Add User</h3>
            <ul className="breadcrumbs flex items-center flex-wrap justify-start gap10">
              <li>
                <Link to="/">
                  <div className="text-tiny">Dashboard</div>
                </Link>
              </li>             
              <li>
                <i className="icon-chevron-right"></i>
              </li>
              <li>
                <div className="text-tiny">Add User</div>
              </li>
            </ul>
          </div>
          {/* <!-- form-add-product --> */}
          <form
            className="tf-section-2 form-add-product"
            onSubmit={handleSubmit}
          >            
            <div className="wg-box">
              <fieldset className="name">
                <div className="body-title mb-10">
                  Name <span className="tf-color-1">*</span>
                </div>
                <input
                  className="mb-10"
                  type="text"
                  placeholder="Enter name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </fieldset>
              <fieldset className="name">
                <div className="body-title mb-10">
                  Username <span className="tf-color-1">*</span>
                </div>
                <input
                  className="mb-10"
                  type="text"
                  placeholder="Enter username"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </fieldset>
              <fieldset className="name">
                <div className="body-title mb-10">
                  Email <span className="tf-color-1">*</span>
                </div>
                <input
                  className="mb-10"
                  type="text"
                  placeholder="Enter email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </fieldset>
              <fieldset className="name">
                <div className="body-title mb-10">
                  Password <span className="tf-color-1">*</span>
                </div>
                <input
                  className="mb-10"
                  type="text"
                  placeholder="Enter password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </fieldset>
              <fieldset className="name">
                <div className="body-title mb-10">
                  Phone <span className="tf-color-1">*</span>
                </div>
                <input
                  className="mb-10"
                  type="text"
                  placeholder="Enter phone"
                  name="phone"
                  value={formData.phone}
                  maxLength="10"
                  onChange={handleChange}
                  required
                />
              </fieldset>

              <div className="cols gap10 mt-4">
                <button className="tf-button style-1 w-full" type="submit">
                  Save User
                </button>
              </div>
            </div>
          </form>
          {/* <!-- /form-add-product --> */}
        </div>
        {/* <!-- /main-content-wrap --> */}
      </div>
    </>
  );
};
export default AddUser;
